import { atom } from "recoil";
import PackageUmrahModel from "../Models/packageomra.model";

export const DefaultTemplateUmrah = new atom({
  default: new PackageUmrahModel(),
  key: "DefaultTemplateUmrah",
});
